import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20Korean%20manhwa%20themed%20banner%20with%20soft%20gradient%20colors%20of%20warm%20coral%20pink%20and%20golden%20yellow%2C%20delicate%20line%20art%20of%20floating%20comic%20panels%2C%20dreamy%20cherry%20blossom%20petals%2C%20abstract%20manga%20speed%20lines%2C%20elegant%20curves%2C%20modern%20webtoon%20aesthetic%2C%20clean%20and%20airy%20feel%2C%20minimalist%20design&width=1800&height=900&seq=hero-bg-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
          好看的韩国漫画
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mb-8 leading-relaxed">
          汇聚众多精彩韩漫作品，免费阅读配合流畅下拉式浏览，智能加载技术确保您在各类设备上获得极致体验。
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300"
          >
            立即阅读
          </Link>
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/40 rounded-full font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/30 transition-all duration-300"
          >
            热门推荐
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}